import type { RenewalSummaryJobStatus, RenewalSummaryStage } from '@domain/schemas/renewal-summary.schema';

export const POLL_INTERVAL_MS = 3_000;

export const JOB_IN_FLIGHT: Record<RenewalSummaryJobStatus, boolean> = {
  PENDING: true,
  RUNNING: true,
  SUCCEEDED: false,
  FAILED: false,
};

export const STAGE_LABEL: Record<RenewalSummaryStage, string> = {
  COMPARING: 'Comparing contracts',
  REVIEWING: 'Reviewing changes',
  DRAFTING: 'Drafting summary',
};
